const SI = {
  governmentalOrganization: [
    "podjetje v državni lasti"
  ],
  listedPublicCompany: [
    "delniška družba (d.d.)"
  ],
  nonProfit: [
    "non-profit društvo"
  ],
  privateCompany: [
    "družba z omejeno odgovornostjo (d.o.o.)"
  ]
};
export {
  SI as default
};
